export default __webpack_public_path__ + "static/media/ratemy1.204f7372.png";